export enum SERVICE_ID {
  LOADING = 'LOADING',
  LDLOADING = 'LDLOADING',
  UNLOADING = 'UNLOADING',
  LDUNLOADING = 'LDUNLOADING',
  TRANSIT = 'TRANSIT',
  LDTRANSIT = 'LDTRANSIT',
  LOADINGUNLOADING = 'LOADINGUNLOADING',
  PACKINGSERVICE = 'PACKINGSERVICE',
  HOURLYLABOR = 'HOURLYLABOR',
}

export const SERVICES = {
  [SERVICE_ID.LDLOADING]: {
    id: SERVICE_ID.LDLOADING,
    name: 'Loading',
  },
  [SERVICE_ID.LDUNLOADING]: {
    id: SERVICE_ID.LDUNLOADING,
    name: 'Unloading',
  },
  [SERVICE_ID.PACKINGSERVICE]: {
    id: SERVICE_ID.PACKINGSERVICE,
    name: 'Packing',
  },
  [SERVICE_ID.LOADINGUNLOADING]: {
    id: SERVICE_ID.LOADINGUNLOADING,
    name: 'Moving Labor',
  },
  [SERVICE_ID.HOURLYLABOR]: {
    id: SERVICE_ID.HOURLYLABOR,
    name: 'Hourly Labor',
  },
};
